module.exports = __webpack_public_path__ + "img/contact-mask.ac668096.svg";